function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M.8 0a1 1 0 0 0-.8.7c0 .4 0 .8.3 1l20 20c.3.3.6.5 1 .4.4-.1.7-.4.8-.8a1 1 0 0 0-.4-1L14.3 13V1.3c0-1.2-1-1.6-2-.7L7.2 5.7 1.7.3A1 1 0 0 0 1 0zm1.5 7a1 1 0 0 0-1 1v6c0 .6.5 1 1 1h3.5l6.5 6.5c1 1 2 .5 2-.9V18L3.3 7h-1z"
});

function SvgNoSound(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 23 23",
    width: 23,
    height: 23,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoSound);
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyMyAyMyIgd2lkdGg9IjIzIiBoZWlnaHQ9IjIzIj48cGF0aCBmaWxsPSJjdXJyZW50Q29sb3IiIGQ9Ik0uOCAwYTEgMSAwIDAgMC0uOC43YzAgLjQgMCAuOC4zIDFsMjAgMjBjLjMuMy42LjUgMSAuNC40LS4xLjctLjQuOC0uOGExIDEgMCAwIDAtLjQtMUwxNC4zIDEzVjEuM2MwLTEuMi0xLTEuNi0yLS43TDcuMiA1LjcgMS43LjNBMSAxIDAgMCAwIDEgMHptMS41IDdhMSAxIDAgMCAwLTEgMXY2YzAgLjYuNSAxIDEgMWgzLjVsNi41IDYuNWMxIDEgMiAuNSAyLS45VjE4TDMuMyA3aC0xeiIvPjwvc3ZnPgo=";
export { ForwardRef as ReactComponent };